import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { languageConfig } from 'translations/languageConfig';

export const getIsBaseLanguage = (language: LangCodeEnum) =>
  !language || language === languageConfig.baseLanguage;
